// extracted by mini-css-extract-plugin
export default {"starterScreen":"im","starterImage":"jm","already":"km","btnContainer":"lm","starterImageMobile":"mm","starterTextContainWrapper":"nm","controlX":"om","attrWrapper":"pm","logoWrapper":"qm","starterTextContain":"rm","starterHeader":"sm","starterBtn":"tm","starterSecondaryBtn":"um","starterBanner":"vm","logoWrapperMob":"wm","mobileBtnContainer":"xm"};
    if(module.hot) {
      // 1715188228945
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  